module.exports = __webpack_public_path__ + "media/nicole11.147cbc71.mp3";